// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.single-spinner{margin:0 auto}.single-spinner .single-spinner-inner{stroke:currentColor}.single-spinner-large{max-width:44px}.single-spinner-small{max-width:22px}`, "",{"version":3,"sources":["webpack://./src/common/components/spinner/spinner.component.scss"],"names":[],"mappings":"AAAA,gBACE,aAAA,CAEA,sCACE,mBAAA,CAIJ,sBACE,cAAA,CAGF,sBACE,cAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
